import { useRequest } from "~/api/Request"
import API from "~/api/api"

export function useTask() {
  const { Request } = useRequest()

  const getTaskData = async () => {
    const res = await Request.get<any[]>(API.TASK)
    return res
  }

  return {
    getTaskData,
  }
}
